import React from 'react';
import * as R from 'ramda';
import { css } from '@emotion/react';
import { Paper } from '@mui/material';
//import {  } from '@mui/icons-material';
import { useQuery } from '@cd/react-query';
import { postJSONPS, either } from '@cd/utils';
import { useStore } from './store';
import Markdown from 'react-markdown';

const wrapStyle = css({
	display: 'flex',
	flexDirection: 'column',
	'> *': { marginBottom: '8px' },
	'> h2': { fontSize: '22px' },
	'> h3': { fontSize: '12px' },
	'> p': { fontSize: '14px' }
});

function useGetSubscriptions(dispatch) {
	const url = `/subscription/check`;

	return useQuery(['getSubscriptions'], () =>
		postJSONPS('GET', url).then(
			either(e => {
				dispatch({ type: 'post error', e });
				throw new Error(e);
			}, R.identity)
		)
	);
}

const SubscribeService = () => {
	const { dispatch } = useStore();
	const { data } = useGetSubscriptions(dispatch);
	return (
		<Paper css={wrapStyle}>
			<Markdown>{data}</Markdown>
		</Paper>
	);
};
export default SubscribeService;
